import { render } from "./ControleSmtpView.vue?vue&type=template&id=a679ccda&scoped=true"
import script from "./ControleSmtpView.vue?vue&type=script&lang=js"
export * from "./ControleSmtpView.vue?vue&type=script&lang=js"

import "./ControleSmtpView.vue?vue&type=style&index=0&id=a679ccda&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a679ccda"]])

export default __exports__